// Import CSS
import "../css/index.css";

// Import JS
import 'flickity-fade';
import 'flickity-as-nav-for';
import Flickity from 'flickity';

/**
 * Fade In Tech
 */
document.addEventListener("DOMContentLoaded", () => {
    const fadeElements = document.querySelectorAll(".ct-fade-in-up, .ct-fade-in-down, .ct-fade-in");

    const handleScroll = () => {
        fadeElements.forEach((el) => {
            const rect = el.getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > 0) {
                el.classList.add("ct-transition");
            }
        });
    };

    // Trigger on scroll and initial load
    window.addEventListener("scroll", handleScroll);
    handleScroll();
});


/**
 * Flickity Sliders.
 */

// Featured posts.
document.querySelectorAll('.ct-featured-posts').forEach(element => {
    const textFlickity = new Flickity( element.querySelector( '.ct-featured-posts-text' ), {
            prevNextButtons: true,
            pageDots: true,
            draggable: false,
            cellAlign: 'left',
            contain: true,
            fade: true,
            autoPlay: false,
            adaptiveHeight: true,
            setGallerySize: false
        }),
        imagesFlickity = new Flickity( element.querySelector( '.ct-featured-posts-images' ), {
            prevNextButtons: false,
            pageDots: false,
            draggable: false,
            cellAlign: 'left',
            contain: true,
            fade: true,
            asNavFor: element.querySelector( '.ct-featured-posts-text' ),
            adaptiveHeight: true,
            setGallerySize: false
        });
});

// Popular tags.
document.querySelectorAll('.ct-popular-tags').forEach(element => {
    const tagsFlickity = new Flickity( element, {
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            contain: true,
        });
});

/**
 * Calculate Scrollbar Width.
 */
const postContent = document.querySelector(".ct-post-content");
if ( postContent ) {
    postContent.style.setProperty("--scrollbar-width", window.innerWidth - document.documentElement.clientWidth + "px");
}

/**
 * Navigation - Handle max menu items.
 */
document.querySelectorAll('.ct-is-submenu > a').forEach(element => {
    element.addEventListener("click", event => {
        event.target.parentNode.classList.toggle('ct-is-active');
        event.preventDefault();
    });
});

/**
 * Remove empty post content divs
 */
document.addEventListener('DOMContentLoaded', function() {
    var postContent = document.querySelector('.ct-page-template .ct-post-content');
    if (postContent && postContent.innerHTML.trim() === '') {
        postContent.remove();
    }
});

/**
 * Remove the # from footer nav headings
 */

// Select all elements with the class .ct-secondary-nav-heading
const elements = document.querySelectorAll('.ct-secondary-nav-heading a');

// Loop through each element
elements.forEach(function(element) {
    // Get the text content of the element
    let text = element.textContent.trim();

    // Check if the text starts with a '#'
    if (text.startsWith('#')) {
        // Remove the first character '#' from the text
        text = text.substring(1);

        // Update the text content of the element
        element.textContent = text;
    }
});


/**
 * Mobile Menu.
 */
document.querySelectorAll('#ct-mobile-nav').forEach(element => document.body.appendChild( element ) );

document.querySelectorAll('#ct-mobile-nav-trigger').forEach(element => {
    element.addEventListener("click", event => {
        document.body.classList.toggle('ct-mobile-nav-active');
        event.preventDefault();
    });
});

document.querySelectorAll('#ct-mobile-nav .ct-close-btn, #ct-mobile-nav .ct-mobile-nav-background-cover').forEach(element => {
    element.addEventListener("click", event => {
        document.body.classList.toggle('ct-mobile-nav-active');
        event.preventDefault();
    });
});

/**
 * Contrast and Color Settings
 */

// Get light or dark contrast
function getContrast(t){return"#"===t.slice(0,1)&&(t=t.slice(1)),3===t.length&&(t=t.split("").map(function(t){return t+t}).join("")),128<=(299*parseInt(t.substr(0,2),16)+587*parseInt(t.substr(2,2),16)+114*parseInt(t.substr(4,2),16))/1e3?"light":"dark"}

// Convert the RGB color to hex
function rgbaToHex(rgba) {
    const values = rgba.match(/[\.\d]+/g);
    if (!values) return null;

    const alpha = values.length === 4 ? Math.round(parseFloat(values[3]) * 255).toString(16).padStart(2, '0') : '';
    return `#${values.slice(0, 3).map(val => Math.round(parseFloat(val)).toString(16).padStart(2, '0')).join('')}${alpha}`;
}

export function applyThemeStyles(){
    let themeStyle = getContrast( themeSettings.backgroundColor ),
        themeAccentStyle = 'accent-' + getContrast( themeSettings.accentColor );

    document.getElementsByTagName('body')[0].classList.add( themeStyle );
    document.getElementsByTagName('body')[0].classList.add( themeAccentStyle );

    // Get all elements with class 'post-primary-tag'
    let postPrimaryTags = document.querySelectorAll('.ct-tag-pill');

    // Loop through the NodeList using a for...of loop
    for (const postPrimaryTag of postPrimaryTags) {
        // Get the computed style of the element
        const computedStyle = window.getComputedStyle(postPrimaryTag),
            backgroundColor = computedStyle.backgroundColor,
            hexColor = rgbaToHex( backgroundColor ),
            contrast = getContrast( hexColor );

        // Add a CSS class based on the contrast
        postPrimaryTag.classList.add(`contrast-${contrast}`);
    }

    return "Styles Generated";
}
window.applyThemeStyles = applyThemeStyles;

document.addEventListener('DOMContentLoaded', function () {
    applyThemeStyles();
}, false);

/**
 * Enable post share button.
 */
import ClipboardJS from 'clipboard';

new ClipboardJS("#copy");
